import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const FlaggedContentRoute = lazyWithRetries(() => import('.'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.flaggedContent(':tab?'),
    element: (
      <StandardPageLayout
        maxWidth={900}
        elementId="flaggedContentRoute"
        title={<T _str="Flagged content" />}>
        <Suspense fallback={<RouteLoading />}>
          <FlaggedContentRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
